import { Helmet } from "react-helmet";
import About from "../Components/About/About";
import Certificate from "../Components/Certificate/Certificate";
import HomeBanner from "../Components/Home/HomeBanner";
import Parallax from "../Components/Parallax/Parallax";
import Services from "../Components/Services/Services";
import VerifyCertificate from "../Components/VerifyCertificate/VerifyCertificate";
import Gallery from "../Gallery/Gallery";
import Tagline from "../TagLine/Tagline";

export default function Home() {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>
          Best Diamond Certification & Testing Lab in India | Sreehari Diamond
          Laboratory{" "}
        </title>
        <meta
          name="description"
          content="Get accurate and trusted diamond certification in India with Sreehari Diamond Laboratory, your expert lab for testing natural and lab-grown diamonds."
        />
        <meta
          name="keywords"
          content="lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Best Diamond Certification & Testing Lab in India | Sreehari Diamond Laboratory"
        />
        <meta
          property="og:description"
          content="Get accurate and trusted diamond certification in India with Sreehari Diamond Laboratory, your expert lab for testing natural and lab-grown diamonds."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sreeharidiamondlab.com/" />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/logo.04f6bad90dcf8391f785.png"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Best Diamond Certification & Testing Lab in India | Sreehari Diamond Laboratory"
        />
        <meta
          name="twitter:description"
          content="Get accurate and trusted diamond certification in India with Sreehari Diamond Laboratory, your expert lab for testing natural and lab-grown diamonds."
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/logo.04f6bad90dcf8391f785.png"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link rel="canonical" href="https://sreeharidiamondlab.com/" />{" "}
      </Helmet>
      <HomeBanner />
      <About />
      <Services />
      <Parallax />
      <Certificate />
      <Gallery />
      <Tagline />
    </>
  );
}
